// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7ed73881","455":"a2cae4ea","561":"c70a0c8a","731":"41e96ccf","977":"d1107e7f"}[chunkId] + ".chunk.js";
};